import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


import Serve from '@/views/online-serve/Serve'
import OnlineServe from '@/views/online-serve/OnlineServe'
import ShopServe from '@/views/online-serve/ShopServe'
import OnlineAd from '@/views/online-serve/OnlineAd'
import VehicleAd from '@/views/vehicle-renewal/VehicleAd'
import Vehicle from '@/views/vehicle-renewal/Vehicle'
import LoansAd from '@/views/vehicle-loans/LoansAd'
import Loans from '@/views/vehicle-loans/Loans'
import Installment from '@/views/vehicle-installment/Installment'
import PartnerAd from '@/views/city-partner/PartnerAd'
import Partner from '@/views/city-partner/Partner'
import Success from '@/views/success/Success'
import Profile from '@/views/profile/Profile'
import ProFileList from '@/views/profile/List'
// import MobileForm from '@/views/profile/MobileForm'
import My from '@/views/profile/My'

Vue.use(VueRouter)

const routes = [
  // 上门服务首页
  {
    path: '/',
    name: 'OnlineAd',
    component: OnlineAd,
  },
  // 上门服务--服务选择
  {
    path: '/onlineServe',
    name: 'OnlineServe',
    component: OnlineServe,
  },
  // 上门服务--提交页面
  {
    path: '/serve',
    name: 'Serve',
    component: Serve,
  },
  // 到店服务
  {
    path: '/shop',
    name: 'ShopServe',
    component: ShopServe,
  },
  // 车辆续保--首页
  {
    path: '/vehiclead',
    name: 'VehicleAd',
    component: VehicleAd
  },
  // 车辆续保--提交页面
  {
    path: '/vehicle',
    name: 'Vehicle',
    component: Vehicle
  },
  {
    path: '/loansad',
    name: 'LoansAd',
    component: LoansAd
  },
  {
    path: '/loans',
    name: 'Loans',
    component: Loans
  },
  // 保险分期页面
  {
    path: '/installment',
    name: 'Installment',
    component: Installment
  },
  {
    path: '/partnerad',
    name: 'PartnerAd',
    component: PartnerAd
  },
  {
    path: '/partner',
    name: 'Partner',
    component: Partner
  },
  {
    path: '/profileList',
    name: 'ProFileList',
    component: ProFileList
  },
  {
    path: '/my',
    name: 'My',
    component: My
  },
  {
    path: '/success',
    name: 'Success',
    component: Success
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
